import Loading from '@/views/loading/loading'

import pc from './modules/pc'

export default [
	{
		path: '/',
		redirect: '/loading'
	},
	{
		path: '/loading',
		name: 'loading',
		component: Loading,
		meta: {
			title: '加载中'
		}
	}
].concat(
	pc
)
